import "../css"
import "./init"
import "./search"

$(document).on("click", ".div-collapsible-header", function() {
  $(this).next(".div-collapsible-details").toggle()
})
